export class Organisation {
  id: number;
  name: string;
  ean_number: string;
  country: string;
  county: string;
  city: string;
  postalcode: string;
  address: string;
  invoice_email: string;
  type: string = 'public';
}



// WEBPACK FOOTER //
// ./src/pages/job/shared/organisation.model.ts